<script>
import {disposeTooltipsByClass, getTooltipById, setupTooltipsByClass} from "@/libs/Helpers";

export default {
  name: 'AboutButton',
  props: {
    propId: {type: String, required: true},
    propShowTooltip: {type: Boolean, default: false},
  },
  watch: {
    propShowTooltip(newValue, oldValue) {
      setTimeout(() => {
        this.showHide(newValue)
      }, 270);
    }
  },
  methods: {
    onButtonClick() {
      this.$emit('onClick');
    },
    createTooltip() {
      let tooltipClass = `.${this.tooltipClass}`;
      disposeTooltipsByClass(tooltipClass);
      setupTooltipsByClass(tooltipClass);
    },
    showHide(status) {
      if (this.tooltipObject !== null) {
        if (status === true)
          this.tooltipObject.show();
        else if (status === false)
          this.tooltipObject.hide();
      }
    }
  },
  computed: {
    tooltipClass() {
      return `tooltip-${this.propId}`;
    },
    tooltipObject() {
      return getTooltipById(this.propId);
    }
  },
  mounted() {
    this.createTooltip();
  },
  updated() {
    this.createTooltip();
  },
  beforeUnmount() {
    this.showHide(false);
  }
}
</script>
<template>
  <div class="about-button">
    <button
        :id="propId"
        class="btn btn-lg btn-purple btn-floating"
        :class="tooltipClass"
        data-bs-toggle="tooltip"
        data-bs-placement="right"
        :data-bs-title="$t('buttons.AboutVisualization')"
        @click="onButtonClick">
      <i class="bi bi-info-circle-fill"></i>
    </button>
  </div>
</template>
